// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const PASS_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accept",
  REJECTED: "reject",
};
